/* eslint-disable no-console */

import { HealthCheckCommand } from "./commands/internal";
export var debugBus = function debugBus(bus) {
  if (typeof window === 'undefined') return bus;
  // FIXME: нужно сделать умный health-check с хранением текущих активных подов
  bus.onCmd(HealthCheckCommand, function (_ref) {
    var uuid = _ref.uuid,
      source = _ref.payload.source;
    if (source !== bus.source) {
      console.log("[".concat(bus.source, "] +++ Got HealthCheck from"), source, uuid);
    } else {
      console.log('>>> Sending Healthcheck', source, uuid);
    }
  });
  var healthCheckTimeout = setTimeout(function () {
    var outgoingCommand = new HealthCheckCommand({
      source: bus.source
    });
    bus.execute(outgoingCommand);
  }, 5000);
  bus.onClose(function () {
    return clearTimeout(healthCheckTimeout);
  });
  return bus;
};

// FIXME: Find a way to debug commands, probably over factories/subscriptions
// import loglevel from 'loglevel';
// import { ChangeNodePropCommand, CreateNodeCommand, MoveNodeCommand } from '@beefco/platform-tools/commands';
// loglevel.setLevel(loglevel.levels.DEBUG);
// const DebugIncludeCommands = [
//   CreateNodeCommand,
//   MoveNodeCommand,
//   ChangeNodePropCommand,
// ].map((cmd) => cmd.type);
// if (DebugIncludeCommands.indexOf(command.type) !== -1) {
//       loglevel.debug(getBusCallLocation(), command.type, command.payload);
//     }
// const getBusCallLocation = () => {
//   if (typeof window === 'undefined') return 'Server';
// };